export default "__VITE_ASSET__ChEwqR7z__"